import React, { useEffect, useState } from 'react';
import { ImageWithFallbackProps } from './types';

const ImageWithFallback: React.FC<ImageWithFallbackProps> = (props) => {
  const [error, setError] = useState<boolean>(false);

  /**
   * @description 重置錯誤旗標
   */
  useEffect(() => {
    setError(false);
  }, [props.src]);

  return (
    <div className={'img-container' + (error ? ' error' : '')}>
      <div className={'error-title' + (error ? ' show' : '')}>{props.imageName}</div>
      <img
        alt={props.alt}
        src={error ? require('assets/images/image-warning.png') : props.src}
        className={error ? 'error' : ''}
        onError={(e) => {
          setError(true);
        }}
      />
      <div className={'error-msg' + (error ? ' show' : '')}>圖片載入失敗</div>
    </div>
  );
};

export default ImageWithFallback;
